import { MWWorkflow, MWWorkflowBE } from '@/types/message-whale/mwWorkflow';

export const mapMWWorkflowBEsToDTO = (workflowBE: MWWorkflowBE): MWWorkflow => {
  return {
    id: workflowBE.id.toString(),
    name: workflowBE.name,
    created: workflowBE.created_at,
    updated: workflowBE.updated_at,
    data: workflowBE.data,
    trigger: workflowBE.trigger,
  };
};

export const mapMWWorkflowsBEsToDTO = (
  workflowBEArray: MWWorkflowBE[]
): MWWorkflow[] => {
  return workflowBEArray.map((workflowBE) => {
    return mapMWWorkflowBEsToDTO(workflowBE);
  });
};

export const mapMWWorkflowDTOToBEForCreate = (
  workflow: Partial<MWWorkflow>
): Partial<MWWorkflowBE> => {
  return {
    name: workflow.name,
    data: workflow.data,
    trigger: workflow.trigger,
  };
};

export const mapMWWorkflowDTOToBEForUpdate = (
  workflow: Partial<MWWorkflow>
): Partial<MWWorkflowBE> => {
  return {
    name: workflow.name,
    data: workflow.data,
    trigger: workflow.trigger,
  };
};
